import React, { memo, useState } from 'react';
import { message } from '$/components/Message';
import { Popover } from 'antd';
import { fetchActivityList } from '$/api/canvasRquest';
import IconFont from '$/components/IconFont';
import { mtstatTrack } from '$/utils/mtstat';
import OverlayContent from './OverlayContent';
import styles from './index.module.scss';

export type ProductOperationList = Awaited<ReturnType<typeof fetchActivityList>>['list'];

function ProductOperation() {
  const [list, setList] = useState<ProductOperationList>([]);
  const [hovered, setHovered] = useState(false);

  const hide = () => {
    setHovered(false);
  };

  const fetchList = async () => {
    try {
      const res = await fetchActivityList();
      setList(Array.isArray(res.list) ? res.list.slice(0, 5) : []);
      mtstatTrack('roboneo_top_guide_hover', {
        activity_id: (Array.isArray(res.list) ? res.list.slice(0, 5) : []).map((item) => item.id).join(','),
      });
    } catch (err: any) {
      if (err.message) {
        // successEchangeRef.current?.open(1);
        message.error(err.message);
      }
    }
  };

  return (
    <div className={styles.container}>
      <Popover
        open={hovered}
        onOpenChange={async (visible) => {
          setHovered(visible);
          if (visible) {
            fetchList();
          }
        }}
        placement="bottomRight"
        trigger={['hover']}
        overlayStyle={{
          zIndex: 'calc(var(--zindex-dropdown) + 1) !important',
        }}
        overlayClassName="resetPopoverAndArrow"
          // eslint-disable-next-line react/no-unstable-nested-components
        content={() => <OverlayContent hide={hide} list={list} />}
      >
        <div
          className={styles['icon-container']}
        >
          <IconFont name="lightBulbV3Bold" fontSize={16} color="var(--content-buttonSecondary)" />
        </div>
      </Popover>
    </div>
  );
}
export default memo(ProductOperation);
